import { createFileRoute } from "@tanstack/react-router";
import { UsagePage } from "../features/ai/usage-page";

export const Route = createFileRoute("/ai-usage")({ component: UsagePage });
